// created by dubinbin
// 参数isSelectIndex 是否要选中某个tab，传null默认不应用，
// tabFixed 顶部固定，需要外部条件判断传入，传null默认不应用，
// tabName:Array ['tab1 NAME','tab2 Name']  必传
// 暴露一个对外方法 在父组件可以通过类似setTabIndex={val=>this.setTabIndex(val)}获取切换过的值
// LineLength 可传可不传，滑动条长度，按设计图给的传入即可

import React from 'react'
import '../../css/component/switchtab/switchtab.css'

class switchTab extends React.Component {
        constructor() {
            super()
            this.state = {
                tab:0
            }
        }

        componentDidMount() {
            const { isSelectIndex } = this.props;
            if(isSelectIndex!==null){
                this.setState({
                    tab: isSelectIndex
                })
            }
        }
        
        componentWillReceiveProps(nextProps) {
            const { tab } = this.state
            const isSelectIndex = nextProps.isSelectIndex;
            if (isSelectIndex !== tab) {
                this.setState({
                    tab: isSelectIndex,
                })
            }
        }

        render() {
            const screenWidth = window.screen.width >=480 ? '480' : window.screen.width ;
            const switchLineLength = this.props.LineLength ? this.props.LineLength : '' ;
            const transformLeft=  parseFloat(screenWidth / 4) - (switchLineLength? switchLineLength / 2: 5) + 'px';
            const transformRight = parseFloat(screenWidth / 4 * 3 ) - (switchLineLength? switchLineLength / 2: 5) + 'px';
            const { tabFixed, tabName } =  this.props;

            return(
                <div className="weui-tab wk-switch-tab">
                    <div className={`channel_nav ${tabFixed && tabFixed!==null? "channelTab_Fixed channel-Tab" : "channel-Tab"}`}>
                        <div className="slideLine" style={this.state.tab ===0  ? {transform: `translateX(${transformLeft})` }: {transform: `translateX(${transformRight})` } } ></div>
                        <div className={"tabItem"}  onClick={
                            () => {
                                this.props.setTabIndex(0);
                                this.setState({
                                    tab:0
                                })
                            }}>
                            <p className={this.state.tab===0?'channelTab_activeText': null}>{tabName[0]}</p>
                        </div>


                        <div className={"tabItem"}  onClick={
                            () => {
                                this.props.setTabIndex(1);
                                this.setState({
                                    tab:1
                                })
                            }}>
                            <p className={this.state.tab===1 ? 'channelTab_activeText': null}>{tabName[1]}</p>
                        </div>
                    </div>
                </div>
            )
    }
}

export default switchTab



// WEBPACK FOOTER //
// ./src/components/wk/WKSwitchTab.js